import Form from 'react-bootstrap/Form';

function BasicInformationSection({
  values,
  handleChange,
  handleBlur,
  errors,
  handleNameChange,
  disabled = false,
}) {
  return (
    <div className='d-flex flex-column gap-3'>
      <h5 id='section-general-information' className='pt-4'>
        Grundinformation
      </h5>
      <Form.Group controlId='BasicInformation.Name'>
        <Form.Label>Tävlingsnamn</Form.Label>
        <Form.Control
          value={values.BasicInformation?.Name}
          onChange={(e) => {
            handleChange(e);
            handleNameChange(e.target.value);
          }}
          onBlur={handleBlur}
          placeholder='Ange tävlingsnamn'
          className='p-2'
          isInvalid={!!errors.BasicInformation?.Name}
          disabled={disabled}
        />
        <Form.Control.Feedback type='invalid'>
          {errors.BasicInformation?.Name}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='BasicInformation.StartDate'>
        <Form.Label>Startdatum</Form.Label>

        <Form.Control
          type='date'
          value={values.BasicInformation?.StartDate}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='Ange startdatum'
          className='p-2'
          isInvalid={!!errors.BasicInformation?.StartDate}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.BasicInformation?.StartDate}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='BasicInformation.EndDate'>
        <Form.Label>Slutdatum</Form.Label>
        <Form.Control
          type='date'
          value={values.BasicInformation?.EndDate}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='Ange slutdatum'
          className='p-2'
          isInvalid={!!errors.BasicInformation?.EndDate}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.BasicInformation?.EndDate}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group controlId='BasicInformation.RegistrationDeadline'>
        <Form.Label>Sista anmälningsdag</Form.Label>
        <Form.Control
          type='date'
          value={values.BasicInformation?.RegistrationDeadline}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='Ange sista anmälningsdag'
          className='p-2'
          isInvalid={!!errors.BasicInformation?.RegistrationDeadline}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.BasicInformation?.RegistrationDeadline}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group controlId='BasicInformation.Venue'>
        <Form.Label>Tävlingsplats</Form.Label>
        <Form.Control
          value={values.BasicInformation?.Venue}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='Ange tävlingsplats'
          className='p-2'
          isInvalid={!!errors.BasicInformation?.Venue}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {errors.BasicInformation?.Venue}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  );
}

export default BasicInformationSection;
